import currencies from './currencySymbols';
import { useRecoilValue } from 'recoil';
import { accountState } from 'state/atoms';

export const useFormatPrice = (currency) => {
  const { defaultCurrencyCode } = useRecoilValue(accountState);

  const formatPrice = (price, currencyCode = currency || defaultCurrencyCode) => {
    // If a currency is not defined on the hook call, fallback to the context
    const symbol = currencies[currencyCode];
    const parsedPrice = parseFloat(price);

    const formattedPrice = parsedPrice.toLocaleString('en-US', {
      minimumFractionDigits: 2,
    });

    return `${symbol}${formattedPrice} ${currencyCode}`;
  };

  return formatPrice;
};
